import * as actionTypes from 'constants/ActionTypes';

export function getCargoDuplicates() {
    return {
        type: actionTypes.GET_CARGO_DUPLICATES.REQUEST,
    };
}

export function deleteCargoDuplicate(item) {
    return {
        type: actionTypes.DELETE_CARGO_DUPLICATE.REQUEST,
        item,
    };
}

export function searchCargoDuplicates(search) {
    return {
        type: actionTypes.SEARCH_CARGO_DUPLICATES,
        search,
    };
}

export function clearDuplicates() {
    return {
        type: actionTypes.CLEAR_DUPLICATES,
    };
}



// WEBPACK FOOTER //
// ./app/actions/cargoes/duplicates.js